<template>
  <nav
    class="sticky-cta container rounded-top p-4"
    :class="{ 'is-stuck': ctaIsStuck }"
    :sticky-side="stickySide"
    on-stick="handleStick"
    v-sticky
  >
    <div class="row justify-content-center px-xl-9">
      <step-indicator v-if="withSteps"></step-indicator>
      <div class="col col-md-auto">
        <slot />
        <div class="valid-until-date text-center">
          <span v-if="isExpired" v-dynamic-content:sticky_cta_offer_is_expired></span>
          <span v-else v-dynamic-content:sticky_cta_offer_expiration_date="[offerExpiryDate]"></span>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import StepIndicator from '@/components/parts/StepIndicator'

export default {
  name: 'StickyCta',
  props: {
    withSteps: {
      type: Boolean,
      default: false,
    },
    stickySide: {
      validator: (value) => ['top', 'bottom'].includes(value),
      default: 'bottom',
    },
  },
  components: {
    StepIndicator,
  },
  computed: {
    ...mapGetters(['isExpired', 'offerExpiryDate']),
  },
  data() {
    return {
      ctaIsStuck: false,
    }
  },
  methods: {
    // https://github.com/mehwww/vue-sticky-directive
    handleStick(event) {
      this.ctaIsStuck = !event.bottom
    },
  },
}
</script>

<style scoped lang="scss">
$white: #fff;

.sticky-cta {
  position: -webkit-sticky;
  position: sticky;
  width: 100% !important;
  bottom: 0;
  z-index: 10;
  background-color: $white;

  // Shadow & border appear when not "stuck":
  box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12);
  border: solid 1px rgba(255, 255, 255, 0.8);

  &.is-stuck {
    box-shadow: none;
    border: none;
  }

  .valid-until-date {
    font-size: calc((13 / 16) * 1rem);
    font-weight: 500;
  }
}
</style>
